import { FocusEvent } from 'react';
import { FormikProps } from 'formik';
import moment, { Moment } from 'moment';

export const scrollIntoView = (
  e:
    | FocusEvent<HTMLInputElement, Element>
    | FocusEvent<HTMLTextAreaElement, Element>,
) =>
  e.target.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'start',
  });

export const ValidateInput = (
  fieldName: string,
  value: any,
  regex: RegExp,
  formik: FormikProps<any>,
  length?: number,
) => {
  if (length && value.toString().length > length) {
    formik.setFieldValue(fieldName, formik.values[`${fieldName}`]);
    return;
  }
  if (!regex.test(value)) {
    formik.setFieldValue(fieldName, formik.values[`${fieldName}`]);
    return;
  }
  formik.setFieldValue(fieldName, value);
};

export const isObjectFullyFilled = (obj: Record<string, any>) => {
  if (Object.keys(obj).length === 0 && obj.constructor === Object) return false;

  return Object.values(obj).every(value => {
    if (typeof value === 'object' && value !== null)
      return isObjectFullyFilled(value);
    return value;
  });
};

export const isObjectPartiallyFilled = (obj: Record<string, any>) =>
  Object.values(obj).some(value => {
    if (typeof value === 'object' && value !== null)
      return isObjectPartiallyFilled(value);
    return !!value;
  });

export const isKTPProfileReadable = (
  formValues: Record<string, any> | undefined | null,
) => {
  if (!formValues) return false;
  return Object.values(formValues).every(key => {
    return !(key === null || key === undefined || key === '');
  });
};

export const getAge = (date: string) => {
  const startDate = moment();
  const endDate = moment(date);

  return startDate.diff(endDate, 'years');
};

export const getAgeByMonths = (date: string) => {
  const startDate = moment().startOf('month');
  const endDate = moment(date).startOf('month');

  return startDate.diff(endDate, 'months');
};

export const getAgeByMonthsWithTenure = (tenure: number, date: string) => {
  const startDate = moment().add(tenure, 'M').startOf('month');
  const endDate = moment(date).startOf('month');

  return startDate.diff(endDate, 'months');
};

const getDiffBirthdayOnFutureYearsAndDate = (
  birthday: Moment | string,
  date: Moment | string,
  nYears: number,
) => {
  const birthdayOnFutureYears = moment(birthday)
    .add(nYears, 'y')
    .startOf('day');
  return birthdayOnFutureYears.diff(date, 'd');
};

export const getDiffBirthdayOnFutureYearsAndTenure = (
  birthday: Moment | string,
  tenure: number,
  nYears: number,
) => {
  const endOfTenure = moment().add(tenure, 'M').startOf('day');
  return getDiffBirthdayOnFutureYearsAndDate(birthday, endOfTenure, nYears);
};

export const getDiffBirthdayOnFutureYearsAndToday = (
  birthday: Moment | string,
  nYears: number,
) => {
  const today = moment().startOf('day');
  return getDiffBirthdayOnFutureYearsAndDate(birthday, today, nYears);
};
